<template>
  <!-- 초대하기 탭 활성화 컨텐츠: 모션 + 친구수 + 혜택안내 + 초대코드 + 유의사항 -->
  <div class="invite-share-tab">
    <InviteMotionBanner />
    <InviteFriendCount
      :count="friendCount"
      @click="openFriendList"
    />
    <InviteBenefitSection />
    <InviteCodeBox
      :code="inviteCode"
      @kakao-click="$emit('kakao-click')"
      @link-click="$emit('link-click')"
    />
    <InviteNoticeSection />

    <InviteFriendListOverlay
      v-if="showFriendList"
      :count="friendCount"
      :friends="friends"
      @close="showFriendList = false"
    />
  </div>
</template>

<script>
import InviteMotionBanner from '@/components/new/organisms/InviteMotionBanner.vue'
import InviteFriendCount from '@/components/new/molecules/InviteFriendCount.vue'
import InviteBenefitSection from '@/components/new/organisms/InviteBenefitSection.vue'
import InviteCodeBox from '@/components/new/molecules/InviteCodeBox.vue'
import InviteNoticeSection from '@/components/new/organisms/InviteNoticeSection.vue'
import InviteFriendListOverlay from '@/components/new/organisms/InviteFriendListOverlay.vue'

export default {
  name: 'InviteShareTab',
  components: {
    InviteMotionBanner,
    InviteFriendCount,
    InviteBenefitSection,
    InviteCodeBox,
    InviteNoticeSection,
    InviteFriendListOverlay,
  },
  props: {
    inviteCode: {
      type: String,
      default: '',
    },
    friendCount: {
      type: [Number, String],
      default: '00',
    },
    friends: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showFriendList: false,
    }
  },
  methods: {
    openFriendList() {
      // 초대한 친구가 0명이면 현황으로 진입하지 않음
      if (!Number(this.friendCount)) return
      this.$emit('friend-list-open')
      this.showFriendList = true
    },
  }
}
</script>

<style scoped>
.invite-share-tab {
  padding-bottom: 102px;
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/InviteShareTab.vue